// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/" + chunkId + "." + {"344":"751bce447a8dfec49e66","359":"26b243798126cdc1d20a"}[chunkId] + ".js";
};